import { Component, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';

import { GfTitleService } from '../../../services/core.title.service';
import { SiteHelpService } from '../site-help.service';
import { SiteHelpSearchResult } from '../site-help.types';

/** Search over the manual. Logged-in users only; the route redirects everyone else to login. */
@Component({
    selector: 'gf-site-help-search',
    template: require('./site-help-search.html')
})
export class SiteHelpSearchComponent implements OnInit {
    searchText = '';
    searching = false;
    searched = false;
    error: string | null = null;
    total = 0;
    results: { slug: string; title: string; excerpt: string }[] = [];

    /** Identifies the latest request, so a slow response cannot overwrite the results of a newer search. */
    private requestId = 0;

    constructor(
        private service: SiteHelpService,
        private stateService: StateService,
        private titleService: GfTitleService
    ) { }

    ngOnInit() {
        this.titleService.setTitle('Search', 'Help');
        this.searchText = this.stateService.params.q || '';
        if (this.searchText) {
            this.search();
        }
    }

    /** Puts the query in the URL so the results page can be reloaded or shared. */
    submit() {
        this.stateService.go('home.site-help.search', { q: this.searchText });
        this.search();
    }

    search() {
        const q = (this.searchText || '').trim();
        if (!q) {
            return;
        }
        const requestId = ++this.requestId;
        this.searching = true;
        this.error = null;
        this.service.search(q, 1, 20)
            .then((response) => {
                if (requestId !== this.requestId) return;
                this.total = response.total;
                this.results = response.results
                    .map((r) => this.toRow(r))
                    .filter((r) => !!r.slug);
                this.searched = true;
                this.searching = false;
            })
            .catch((err) => {
                if (requestId !== this.requestId) return;
                this.error = err && err.status === 503
                    ? 'Search is still starting up. Try again in a moment.'
                    : 'Search is not available right now.';
                this.searching = false;
            });
    }

    /** Leaves the search view for the page that was being read, or the default page. */
    cancel() {
        this.stateService.go('home.site-help.page', { page: this.service.lastPage || SiteHelpService.DEFAULT_PAGE });
    }

    private toRow(r: SiteHelpSearchResult) {
        const text = (r.chunk_text || '').replace(/\s+/g, ' ').trim();
        return {
            slug: SiteHelpService.slugFromUrl(r.source.source_url || '') || '',
            title: r.source.title || '',
            excerpt: text.length > 240 ? text.substring(0, 240) + '…' : text
        };
    }
}
